import React from 'react';
import * as THREE from "three"
import { useRef, useState, useEffect, useMemo, Suspense } from 'react'
import { extend, Canvas, useFrame, Dom, useLoader, useThree } from 'react-three-fiber'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { GUI } from 'three/examples/jsm/libs/dat.gui.module.js';

extend({ OrbitControls, TransformControls });

////////////// UTIL BONE FUNCTION /////////////////

function setupDatGui(gui, mesh, rz) {


  var folder = null //gui.addFolder( "General Options" );


  var bones = mesh.skeleton.bones;
  console.log(bones)
  for (var i = 0; i < bones.length; i++) {

    var bone = bones[i];

    folder = gui.addFolder(bone.name);

    // folder.add( bone.position, 'x', - 10 + bone.position.x, 10 + bone.position.x );
    // folder.add( bone.position, 'y', - 10 + bone.position.y, 10 + bone.position.y );
    // folder.add( bone.position, 'z', - 10 + bone.position.z, 10 + bone.position.z );

    folder.add(bone.rotation, 'x', - Math.PI * 0.5, Math.PI * 0.5);
    folder.add(bone.rotation, 'y', - Math.PI * 0.5, Math.PI * 0.5);
    folder.add(bone.rotation, 'z', - Math.PI * 0.5, Math.PI * 0.5);


    folder.add(bone.scale, 'x', 0, 2);
    folder.add(bone.scale, 'y', 0, 2);
    folder.add(bone.scale, 'z', 0, 2);

    // folder.__controllers[ 0 ].name( "position.x" );
    // folder.__controllers[ 1 ].name( "position.y" );
    // folder.__controllers[ 2 ].name( "position.z" );

    folder.__controllers[0].name("rotation.x");
    folder.__controllers[1].name("rotation.y");
    folder.__controllers[2].name("rotation.z");

    folder.__controllers[3].name("scale.x");
    folder.__controllers[4].name("scale.y");
    folder.__controllers[5].name("scale.z");

  }

}

function SetPose(mesh, Modelbones) {
  var bones = mesh.skeleton.bones;

  for (var i = 0; i < bones.length; i++) {
    var bone = bones[i];
    if (bone.name in Modelbones) {
      // update only if bone exists in the body lol
      for (var key in Modelbones[bone.name]) {
        // check if the property/key is defined in the object itself, not in parent
        if (key == "desc") {
          continue
        }
        for (var axis in Modelbones[bone.name][key]) {
            bone[key][axis] = Modelbones[bone.name][key][axis]
        }
      }

    }

  }
}

////////////////////////////////////////////////////


export function Man2(props) {
  const group = useRef()
  // const camera = props.camera
  // const gl = props.gl
  // const scene = props.scene
  const { camera, gl, scene } = useThree();
  const [transformControl, setTControl] = useState();
  // const { nodes, animations } = useLoader(GLTFLoader, "/assets/3d/man2.glb")
  const { nodes, animations } = useLoader(GLTFLoader, props.model.model_name)


  // console.log(nodes)

  useEffect(() => {
    const callback = (event) => {
      props.orbit.current.enabled = !event.value
    }

    if (!transformControl && group.current) {
      let transformC = new TransformControls(camera, gl.domElement);
      scene.add(transformC);
      // setTControl(transformC);
      transformC.attach(group.current);
      transformC.addEventListener('dragging-changed',
        callback)
    }

    return () => {
      if (transformControl) {
        scene.remove(transformControl);
        setTControl(undefined);
      }
    };
  }, [transformControl, camera, scene, gl]);

  SetPose(nodes[props.model.geometry_name], props.modelBones)


  return (
    <group ref={group} {...props} position={[5, 0, 0]} scale={[props.model.scale, props.model.scale, props.model.scale]} dispose={null}>
      <group >
        <primitive object={nodes[props.model.group_name]} />
        <skinnedMesh geometry={nodes[props.model.geometry_name].geometry} skeleton={nodes[props.model.geometry_name].skeleton} >
          <meshPhongMaterial color="#ffffff"
            attach="material"
            flatShading
            skinning
            emissive="#072534" />
        </skinnedMesh>
      </group>
    </group>
  )
}


export function Woman(props) {
  const [model, setModel] = useState();
  // const { camera, gl, scene } = useThree();
  const camera = props.camera
  const gl = props.gl
  const scene = props.scene

  const meshRef = useRef();
  // const controlsRef = useRef();

  const [transformControl, setTControl] = useState();
  useEffect(() => {
    new GLTFLoader().load('/assets/3d/woman.glb', setModel)
  })


  useEffect(() => {
    const callback = (event) => {
      props.orbit.current.enabled = !event.value
    }
    // transControl.addEventListener("dragging-changed", callback)
    if (!transformControl && meshRef.current) {
      let transformC = new TransformControls(camera, gl.domElement);
      scene.add(transformC);
      setTControl(transformC);
      transformC.attach(meshRef.current);
      transformC.addEventListener('dragging-changed',
        callback)
    }

    return () => {
      if (transformControl) {
        scene.remove(transformControl);
        setTControl(undefined);
      }
    };
  }, [transformControl, camera, scene, gl]);



  return <mesh
    ref={meshRef}
    position={[-5, 0, 0]}
  >
    {model ? <primitive
      object={model.scene}
      scale={[0.2, 0.2, 0.2]}

      dispose={null} /> : null}
  </mesh>
}


export function FallBackBox() {
  // Load this when model fails to load
  return (
    <mesh>
      <boxBufferGeometry attach="geometry" args={[0, 0, 0]} />
      <meshStandardMaterial attach="material" transparent opacity={0.5} />
    </mesh>
  )
}

